<template>
  <div class="uk-section">
    <div class="uk-container">
      <div class="uk-article">
        <h1 class="uk-article-title" v-html="post.title.rendered"></h1>
        <div class="uk-article-lead" v-html="post.excerpt.rendered"></div>
        <div id="postContent" v-html="postContent"></div>
      </div>
      <button class="uk-button uk-button-primary" @click="fbShare">Share on Facebook</button>
      <button class="uk-button uk-button-default" @click="fbComments" v-if="!comments">Load Comments</button>
      <div id="fb-comments" class="fb-comments" :data-href="'http://faithit.com/' + $route.params.slug" data-numposts="5" data-width="100%"></div>
      <a href="#share-modal" id="share-button" uk-toggle class="uk-icon-button uk-box-shadow-large uk-button-primary" uk-icon="icon: social; ratio: 2"></a>
    </div>
    <div id="share-modal" class="uk-flex-top" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">

        <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-modal-header">
            <h2 class="uk-modal-title uk-text-center">Share</h2>
        </div>
        <p class="uk-text-center share-buttons">
        <a :href="facebookShare" class="uk-icon-button uk-box-shadow-medium uk-button-primary" uk-icon="icon: facebook; ratio: 1.5" target="_blank"></a>
        <a :href="twitterShare" class="uk-icon-button uk-box-shadow-medium uk-button-primary" uk-icon="icon: twitter; ratio: 1.5" target="_blank"></a>
        <a :href="pinterestShare" class="uk-icon-button uk-box-shadow-medium uk-button-primary" uk-icon="icon: pinterest; ratio: 1.5" target="_blank"></a>
        <!--<a href="#" class="uk-icon-button uk-box-shadow-medium uk-button-primary" uk-icon="icon: mail; ratio: 1.5" target="_blank"></a>-->
        </p>

      </div>
    </div>
  </div>
</template>
<script>
/* global FB */
import axios from 'axios'
import store from '../store'

export default {
  data () {
    return {
      post: store.selectedPost,
      inlineAds: 0,
      comments: false
    }
  },
  created () {
    this.fbInit();
  },
  mounted () {
    console.log("post mounted");
    document.body.scrollTop = document.documentElement.scrollTop = 0
    if (store.selectedPost === undefined) {
      axios.get('https://faithit.com/wp-json/wp/v2/posts?slug=' + this.$route.params.slug)
        .then(response => {
          let result = response.data[0]
          store.selectedPost = result
          this.post = result
        })
        .catch(e => {
          this.errors.push(e)
          console.log(e)
        })
    }

    this.addAds();

    FB.XFBML.parse(document.body);
  },
  methods: {
    fbInit() {
      window.fbAsyncInit = function() {
        FB.init({
          appId            : '1415952248472022',
          autoLogAppEvents : true,
          xfbml            : true,
          version          : 'v2.11'
        });
      };

      (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    },
    fbComments () {
      FB.XFBML.parse(document.getElementById('fb-comments'))
      this.comments = true
    },
    fbShare () {
      FB.ui({
        method: 'share',
        href: 'https://faithit.com/' + this.$route.params.slug
      }, function (response) {})
    },
    prebidInit () {
      (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://faithit.com/wp-content/themes/faithit-v3/assets/js/dfp-single.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'prebid-jssdk'));
    },
    // Doesn't work on initial page load
    addAds () {
      var element = document.getElementById('postContent')
      for (var i = 1; i <= element.children.length; i++) {
        if (i % 7 === 1 && this.inlineAds < 4) {
          this.inlineAds++;
          element.children[i].insertAdjacentHTML('afterend', 'ad here<div id="inline-mobile' + this.inlineAds + '" class="uk-text-center"><script type="text/javascript">googletag.cmd.push(function() { googletag.display("inline-mobile' + this.inlineAds + '"); });<\/script></div>')
        }
      }
      element.children[0].insertAdjacentHTML('afterend', `<meta property="inline-ad-count" content="${this.inlineAds}">`);
      console.log('add count: ' + this.inlineAds);
      this.prebidInit();
      fetchHeaderBids();
    }
  },
  computed: {
    postContent () {
      return this.post.content.rendered.replace(/(http:\/\/faithit\.com\/wp-content\/)/g, 'https://faithit-eszuskq0bptlfh8awbb.stackpathdns.com/wp-content/')
    },
    facebookShare () {
      return `https://www.facebook.com/sharer/sharer.php?u=https%3A//faithit.com/${this.$route.params.slug}`;
    },
    twitterShare () {
      var content = `${this.post.title.rendered} https://faithit.com/${this.$route.params.slug} via @sharefaithit`
      return `https://twitter.com/home?status=${encodeURIComponent(content)}`;
    },
    pinterestShare () {
      var image = encodeURIComponent(this.post.better_featured_image.source_url.replace(/(http:\/\/faithit\.com)/g, 'https://faithit-eszuskq0bptlfh8awbb.stackpathdns.com'));
      var description = encodeURIComponent(this.post.title.rendered);
      return `https://pinterest.com/pin/create/button/?url=https%3A//faithit.com/${this.$route.params.slug}&media=${image}&description=${description}`;
    }
  }
}
</script>
<style>
#postContent img{
  margin: 0 -1.5rem;
  max-width: calc(100% + 3rem);
  width: calc(100% + 3rem)!important;
}
#postContent iframe{
  margin: 0 -1.5rem;
  max-width: calc(100% + 3rem);
  width: calc(100% + 3rem);
  height: 200px;
  }
#postContent .p1{
  margin: 1em 0;
}

#share-button{
  position: fixed;
  bottom: 25px;
  right: 25px;
  width: 60px;
  height: 60px;
}

.share-buttons a{
  width:45px;
  height:45px;
}

#postContent .uk-text-center iframe {
margin:0;
max-width:initial;
width: initial;
height: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/PostView.vue